import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export type BagIconProps = IconClientSVGProps & {
  filled?: boolean;
};

export const BagIcon = forwardRef<SVGSVGElement, BagIconProps>(
  ({ label, filled = false, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          ref={ref}
          {...props}
        >
          {filled ? (
            <>
              <path
                d="M4.18183 5.83433C4.18183 5.44302 4.20489 5.02086 4.26418 4.59378M11.8182 5.83433C11.8182 5.44302 11.7951 5.02086 11.7358 4.59378M4.26418 4.59378H1.38182L1 17H15L14.6182 4.59378H11.7358M4.26418 4.59378H11.7358M4.26418 4.59378C4.92943"
                fill="currentColor"
              />
              <path
                d="M4.18183 5.83433C4.18183 5.44302 4.20489 5.02086 4.26418 4.59378M11.8182 5.83433C11.8182 5.44302 11.7951 5.02086 11.7358 4.59378M4.26418 4.59378H1.38182L1 17H15L14.6182 4.59378H11.7358M4.26418 4.59378H11.7358M4.26418 4.59378C4.92943 -0.197926 11.0706 -0.197926 11.7358 4.59378"
                stroke="currentColor"
                strokeLinecap="square"
                strokeLinejoin="bevel"
              />
            </>
          ) : (
            <>
              <path
                d="M4.18183 5.83433C4.18183 5.44302 4.20489 5.02086 4.26418 4.59378M11.8182 5.83433C11.8182 5.44302 11.7951 5.02086 11.7358 4.59378M4.26418 4.59378H1.38182L1 17H15L14.6182 4.59378H11.7358M4.26418 4.59378H11.7358M4.26418 4.59378C4.92943 -0.197926 11.0706 -0.197926 11.7358 4.59378"
                stroke="currentColor"
                strokeLinecap="square"
                strokeLinejoin="bevel"
              />
            </>
          )}
        </svg>
      </Icon>
    );
  },
);

BagIcon.displayName = "BagIcon";
